/**
 * Engine constants — part of the cross-engine contract. The Kotlin engine
 * (android/core-dsp) must use these exact values; any change here requires a
 * conformance run AND the mirrored change there.
 */

export const DEFAULT_SAMPLE_RATE = 48000;

/** Limiter ceiling: -1 dBFS. No output sample may exceed this, ever. */
export const LIMITER_CEILING = Math.pow(10, -1 / 20);

/** Limiter gain-envelope release time constant (seconds). Attack is instant. */
export const LIMITER_RELEASE_SEC = 0.05;

/** Voice-ducking attack/release ramp length (seconds), linear in dB. */
export const DUCK_RAMP_SEC = 0.1;

/** Gains at or below this many dB render as exact digital silence. */
export const SILENCE_FLOOR_DB = -120;
